import React from 'react';
import Banner from '../Components/Banner';
import Features from '../Components/Features';
import About from '../Components/About';
import Case from '../Components/Case';
import Offer from '../Components/Offer';
import Gallery from '../Components/Gallery';
import Team from '../Components/Team';
import Testmonial from '../Components/Testmonial';

const Home = () => {
  return (
    <div>
      <Banner />
      <About />
      <Features />
      <Case />
      <Offer />
      <Gallery />
      {/* <Team /> */}
      <Testmonial />
    </div>
  );
};

export default Home;
